import {
	ADMINGETLOYALTYPOINT_SUCCESS,
	ADMINGETLOYALTYPOINT_FAILED,
	RESET_ADMINGETLOYALTYPOINT,
	LOADING_ADMINGETLOYALTYPOINT,
	NETWORK_ERROR_ADMINGETLOYALTYPOINT
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAdminGetLoyaltyPoint = () => {
	return { type: RESET_ADMINGETLOYALTYPOINT };
};

const adminGetLoyaltyPoint = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINGETLOYALTYPOINT });
	await partnerServices
		.post("getLoyaltyPointsList", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminGetLoyaltyPointsuccess(res.data));
					break;
				default:
					dispatch(adminGetLoyaltyPointFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINGETLOYALTYPOINT,
				payload: err
			});
		});
};
function adminGetLoyaltyPointsuccess(data) {
	return {
		type: ADMINGETLOYALTYPOINT_SUCCESS,
		payload: data
	};
}
function adminGetLoyaltyPointFailed(data) {
	return {
		type: ADMINGETLOYALTYPOINT_FAILED,
		payload: data
	};
}

export { resetAdminGetLoyaltyPoint, adminGetLoyaltyPoint };
